import { AxiosError } from "axios";

export const VIEW_AS_REFUSAL_CODES = {
  INVALID: "IMPERSONATION_INVALID",
  UNSUPPORTED: "IMPERSONATION_UNSUPPORTED",
  /** The feature is off; the end call is refused with it too. */
  DISABLED: "IMPERSONATION_DISABLED",
} as const;

export type ViewAsRefusalCode =
  (typeof VIEW_AS_REFUSAL_CODES)[keyof typeof VIEW_AS_REFUSAL_CODES];

export const VIEW_AS_READ_ONLY_MESSAGE =
  "Read-only while viewing as an investor";

export const VIEW_AS_READ_ONLY_TOAST_ID = "view-as-read-only";

export const VIEW_AS_ENDED_ERROR = "The viewing session has ended";

const VIEW_AS_ENDED_ERROR_NAME = "ViewAsEndedError";

export const createViewAsEndedError = (): Error =>
  Object.assign(new Error(VIEW_AS_ENDED_ERROR), {
    name: VIEW_AS_ENDED_ERROR_NAME,
  });

export const isViewAsEndedError = (error: unknown): boolean =>
  (error as { name?: unknown })?.name === VIEW_AS_ENDED_ERROR_NAME;

export const readViewAsRefusalCode = (
  error: AxiosError
): ViewAsRefusalCode | null => {
  if (error?.response?.status !== 403) return null;

  const { code } = (error.response.data ?? {}) as { code?: unknown };

  return (
    Object.values(VIEW_AS_REFUSAL_CODES).find((refusal) => refusal === code) ??
    null
  );
};
